import { Injectable } from '@angular/core';
declare const grecaptcha: any;

@Injectable({
  providedIn: 'root',
})
export class RecaptchaService {
  private siteKey = '6LeZgcsqAAAAAFX9bcjnpWtC-oiGNNTecCJVzr2e';

  constructor() {
    this.loadRecaptcha();
  }

  async reCAPTCHA(option: string): Promise<string> {
    return new Promise(async (resolve, reject) => {
      try {
        const token = await this.execute(option);
        resolve(token);
      } catch (error) {
        console.error('Error ejecutando reCAPTCHA:', error);
        reject(error);
      }
    });
  }

  private loadRecaptcha() {
    localStorage.removeItem('recaptcha_token');
    const scriptId = 'recaptcha-enterprise';
    if (document.getElementById(scriptId)) {
      return;
    }

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${this.siteKey}`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }

  async execute(action: string): Promise<string> {
    return new Promise((resolve, reject) => {
      if (!grecaptcha) {
        reject('reCAPTCHA no está cargado');
        return;
      }

      grecaptcha.enterprise.ready(() => {
        grecaptcha.enterprise.execute(this.siteKey, { action }).then(
          (token: string) => {
            localStorage.setItem('recaptcha_token', token);
            resolve(token)
          },
          (error: any) => {
            localStorage.removeItem('recaptcha_token');
            reject(error)
          }
        );
      });
    });
  }
}
